import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, tooltipClick, cellWidth } from '@/components/TableCell';
import moment from 'moment';

const TableContent = ({
    renderData: {
        dataList = [],
        pageNum = 1,
        pageSize = 30,
        resultTotal = 0
    } = {},
    tableAction,
    paginationChange
}) => {

    const tableOperate = (text, item) => {
        return (
            <div className={styles.action}>
                {
                    item.status === 'FAIL' && <div className={styles.item} onClick={() => tableAction('edit', item)}>编辑</div>
                }
                {
                    (item.status === 'FAIL' || item.status === 'PASS') && <div className={styles.item} onClick={() => tableAction('reset', item)}>重置密码</div>
                }
                {
                    item.status !== 'WAIT' && item.status !== 'FAIL' && item.status !== 'UPDATE_WAIT' && <div className={styles.item} onClick={() => tableAction('change', item)}>变更公司</div>
                }
                {/* {
                    item.status === 'PASS' && <div className={styles.item} onClick={() => tableAction('ban', item)}>封禁</div>
                }
                {
                    item.status === 'DISABLE' && <div className={styles.item} onClick={() => tableAction('open', item)}>启用</div>
                } */}
                <div className={styles.item} onClick={() => tableAction('set', item)}>设置区域</div>
                <div className={styles.item} onClick={() => tableAction('rateModal', item)}>费率设置</div>
            </div>
        );
    };

    const timeCell = (text, item) => {
        if (item.agrtStartTime && item.agrtEndTime) {
            return `${moment(item.agrtStartTime).format('YYYY-MM-DD')} - ${moment(item.agrtEndTime).format('YYYY-MM-DD')}`;
        } else if (item.agrtStartTime && !item.agrtEndTime) {
            return `${moment(item.agrtStartTime).format('YYYY-MM-DD')}`;
        } else if (!item.agrtStartTime && item.agrtEndTime) {
            return `${moment(item.agrtEndTime).format('YYYY-MM-DD')}`;
        } else {
            return '-';
        }
    };

    const columns = [
        {
            title: '运营公司名称',
            dataIndex: 'companyName',
            key: 'companyName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(text, () => {
                tableAction('detail', record);
            }, 'left')
        },
        {
            title: '省份',
            dataIndex: 'provinceName',
            key: 'provinceName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '经纪人数量',
            dataIndex: 'brokerNum',
            key: 'brokerNum',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '负责人',
            dataIndex: 'principalName',
            key: 'principalName',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '联系电话',
            dataIndex: 'contactTel',
            key: 'contactTel',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'statusName',
            key: 'statusName',
            width: cellWidth.small,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '起迄日期',
            dataIndex: 'date',
            key: 'date',
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: timeCell
        },
        {
            title: '管理费比率(%)',
            dataIndex: 'opRatio',
            key: 'opRatio',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(text, () => {
                tableAction('raterecord', record);
            })
        },
        {
            title: '操作',
            dataIndex: 'companyInfoId',
            key: 'companyInfoId',
            align: 'center',
            width: cellWidth.big,
            fixed: 'right',
            render: tableOperate
        },
    ];

    return <div className={styles.tableContainer} style={{ height: '100%' }}>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={item => item.companyInfoId}
            columns={columns}
            dataSource={dataList}
            pagination={false}
            scroll={{ y: true }}
        />
        <XPagination
            resultTotal={resultTotal}
            pageSize={pageSize}
            pageNum={pageNum}
            onChange={paginationChange}
        />
    </div>;
};

TableContent.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableContent;

